module.exports = __webpack_public_path__ + "PatientWithPhone___1laVd.svg";